var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{class:_vm.className,attrs:{"to":{ name: _vm.toRouteName },"event":''},nativeOn:{"click":function($event){return _vm.handleClick($event)}}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }